import { render, staticRenderFns } from "./report-detail.vue?vue&type=template&id=c558900e&scoped=true"
import script from "./report-detail.vue?vue&type=script&lang=js"
export * from "./report-detail.vue?vue&type=script&lang=js"
import style0 from "./report-detail.vue?vue&type=style&index=0&id=c558900e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c558900e",
  null
  
)

export default component.exports